import { AutomatorBuilderPublishSetting } from '../_base';
import { customElement } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-setting-created-on' )
export class AutomatorBuilderPublishSettingCreatedOn extends AutomatorBuilderPublishSetting {
	// Unique identifier for this setting.
	settingID = 'recipe_created_on';

	// Icon representing this setting in the UI.
	icon = 'calendar';

	// Label displayed for this setting in the UI.
	label = escapeHTML( __( 'Created on', 'uncanny-automator' ) );

	/**
	 * Retrieves a readable version of the "Created on" date
	 *
	 * @return {String} The date the recipe was created
	 */
	get readableValue() {
		// Get the value of the field "User type"
		const createdOn = this.getFieldValue( 'CREATED_ON' );

		return createdOn;
	}
}
